<template>
  <div class="group-list">
    <div class="input-group">
      <select ref="select" class="item-select form-control"></select>
      <div class="input-group-append">
        <button class="btn btn-default" type="button" :disabled="!pool.length" @click="add"><i class="fa fa-plus"></i> Add</button>
      </div>
    </div>

    <ul class="list-group">
      <li class="list-group-item item-data" v-for="(item, index) in items" v-cloak :key="item.id">
        <div class="info">
          <h4 class="list-group-item-heading">{{ item.name }}</h4>
        </div>

        <div class="btn-group actions">
          <button class="btn btn-danger" @click.prevent="remove(item, index)">Remove</button>
        </div>

        <input :name="'groups[' + index + ']'" :value="item.id" type="hidden">
      </li>
    </ul>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Choices from 'choices.js'

  let choices = null
  let placeholder = {
    id: 0,
    name: 'Select an item to add...',
    disabled: true,
    selected: true,
    placeholder: true
  }

  export default {
    props: ['content', 'assigned'],
    data () {
      return {
        items: []
      }
    },
    computed: {
      pool () {
        let data = _.differenceBy(this.content, this.items, 'id')

        if (data.length)
          data.unshift(placeholder)

        return data
      }
    },
    watch: {
      items (value) {
        this.updateChoices()
      }
    },
    methods: {
      add () {
        let selectedID = choices.getValue(true)
        let item = _.find(this.content, { id: parseInt(selectedID) })

        if (!item) {
          console.warn('Item not found.')
          return
        }

        item = _.cloneDeep(item)

        console.log(item)

        this.items = _.union(this.items, [item])
      },
      remove (item, index) {
        this.items.splice(index, 1)
      },
      updateChoices () {
        let data = this.pool.concat()

        if (data.length) {
          choices.enable()
        } else {
          choices.disable()
        }

        data.forEach((item) => {
          item.value = item.id.toString()
          item.label = item.name
        })
      
        choices.setChoices(data, 'value', 'label', true)
      }
    },
    mounted () {
      // setup item select
      choices = new Choices(this.$refs.select)
      const items = this.assigned.slice()

      this.items = items
    }
  }
</script>

<style lang="scss">
  .input-group {
    margin-bottom: 15px;
  }

  .item-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;

    .info {
      flex-grow: 1;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
</style>